import { cn } from "@/lib/utils";

interface DataTablePrimaryTextProps {
  children: string;
  className?: string;
}

/**
 * Primary label in a data table cell.
 * Wraps onto multiple lines so long names never overlap neighboring columns.
 */
export function DataTablePrimaryText({
  children,
  className,
}: DataTablePrimaryTextProps) {
  return (
    <span
      className={cn(
        "break-words font-medium leading-snug text-surface-900",
        className,
      )}
      title={children}
    >
      {children}
    </span>
  );
}
